// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2b-W8","rootCenter":"LoadMoreObserver_rootCenter__9wvn1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1A1hN"};